var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3553_15234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.29499 6.80205C1.22212 6.68668 1.18569 6.62899 1.1653 6.54001C1.14998 6.47318 1.14998 6.36778 1.1653 6.30095C1.18569 6.21197 1.22212 6.15428 1.29499 6.03891C1.89711 5.0855 3.68938 2.67529 6.4207 2.67529C9.15201 2.67529 10.9443 5.0855 11.5464 6.03891C11.6193 6.15428 11.6557 6.21197 11.6761 6.30095C11.6914 6.36778 11.6914 6.47318 11.6761 6.54001C11.6557 6.62899 11.6193 6.68668 11.5464 6.80205C10.9443 7.75546 9.15201 10.1657 6.4207 10.1657C3.68938 10.1657 1.89711 7.75546 1.29499 6.80205Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.07005,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4207 8.02556C7.30716 8.02556 8.02578 7.30694 8.02578 6.42048C8.02578 5.53402 7.30716 4.8154 6.4207 4.8154C5.53423 4.8154 4.81562 5.53402 4.81562 6.42048C4.81562 7.30694 5.53423 8.02556 6.4207 8.02556Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.07005,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3553_15234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8406,
    height: 12.8406,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadview);
export default __webpack_public_path__ + "static/media/uploadview.178211920c5d1c5a4557d969fc8b4b1d.svg";
export { ForwardRef as ReactComponent };